import "./App.css";
import Home from "./pages/Home";
// !react-icons: 1-yarn add react-icons
//!2- import { AiOutlineDelete } from "react-icons/ai"
// import { AiOutlineDelete } from "react-icons/ai"

const App = () => {
    return (
        <div>
            <Home />
            {/* <AiOutlineDelete className="text-danger fs-3" /> */}
        </div>
    );
};

export default App;
